export default {"src":"/_next/static/media/footer_youtube.6e98a091.svg","height":14,"width":17,"blurWidth":0,"blurHeight":0};